export const formatDate = (date) => {

    if (date === " 0" || date === " ") {
        return "Por definir"
    }
    const deafultCalendar = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    const formatTime = (time) => {
        let hour = time.split(':')[0];
        let minute = time.split(':')[1];
        if (hour >= 12) {
            if (hour == 12) {
                let h = hour
                let m = minute + ' pm'
                return h + ":" + m
            } else {
                let h = hour - 12
                let m = minute + ' pm'
                return h + ":" + m
            }

        } else {
            let h = parseInt(hour)
            return h + ':' + minute + ' am'
        }
    }
    const dias = [
        'Domingo',
        'Lunes',
        'Martes',
        'Miércoles',
        'Jueves',
        'Viernes',
        'Sábado',
        'Domingo',
    ];
    const numeroDia = new Date(date).getDay();
    const nombreDia = dias[numeroDia];
    if (date.length <= 10) {
        const fecha = date.split('-')
        const f = deafultCalendar[fecha[1] - 1] + " " + fecha[2];
        return f
    } else {
        const dat = date.split(' ')
        const datt = dat[0].split('-')
        const f = nombreDia + " " + datt[2] + " de " + deafultCalendar[datt[1] - 1] + (dat[1] !== "" ? " - " : " ") + (dat[1] ? formatTime(dat[1]) : "");
        return f
    }
}

export const formatDateWithoutHour = (date) => {
    const deafultCalendar = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    const dias = [
        'Domingo',
        'Lunes',
        'Martes',
        'Miércoles',
        'Jueves',
        'Viernes',
        'Sábado',
        'Domingo',
    ];
    const numeroDia = new Date(date).getDay();
    const nombreDia = dias[numeroDia];
    if (date.length <= 10) {
        const fecha = date.split('-')
        const f = deafultCalendar[fecha[1] - 1] + " " + fecha[2];
        return f
    } else {
        const dat = date.split(' ')
        const datt = dat[0].split('-')
        const f = nombreDia + " " + datt[2] + " de " + deafultCalendar[datt[1] - 1] + (dat[1] !== "" ? ", " : " ") + datt[0];
        return f
    }
}

export const formatDateHours = (date) => {
    const deafultCalendar = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    const formatTime = (time) => {
        let hour = time.split(':')[0];
        let minute = time.split(':')[1];
        if (hour >= 12) {
            if (hour == 12) {
                let h = hour
                let m = minute + ' pm'
                return h + ":" + m
            } else {
                let h = hour - 12
                let m = minute + ' pm'
                return h + ":" + m
            }

        } else {
            let h = parseInt(hour)
            return h + ':' + minute + ' am'
        }
    }

    if (date.length <= 10) {
        const fecha = date.split('-')
        const f = deafultCalendar[fecha[1] - 1] + " " + fecha[2];
        return f
    } else {
        const dat = date.split(' ')
        //const datt = dat[0].split('-')
        const f = (dat[1] ? formatTime(dat[1]) : "");
        return f
    }
}

export const compareDates = (date) => {
    let today = new Date();
    let Christmas = new Date(date);
    let diffMs = (Christmas - today); // milliseconds between now & Christmas
    let diffDays = Math.floor(diffMs / 86400000); // days
    let diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
    // let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
    if (diffDays >= 1) {
        return true;
    } else if (diffDays === 0 && diffHrs > 0) {
        return false;
    } else {
        return false;
    }
}
export const compareDatesLog = (date, lapse) => {
    let today = new Date();
    let Christmas = new Date(date);
    let diffMs = (Christmas - today); // milliseconds between now & Christmas
    let diffDays = Math.floor(diffMs / 86400000); // days
    let diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
    let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
    if (diffDays <= 0 && diffMins <= lapse && diffHrs <= 0) {
        return true;
    } else {
        return false;
    }
}

export const isUserAllowedToEnter = (startDate, endDate) => {
    let currentDate = new Date();
    let enterTime = new Date(startDate)
    enterTime.setMinutes(startDate.getMinutes() - 15)
    return (currentDate.getTime() > enterTime.getTime() && currentDate.getTime() < endDate.getTime())
  }